import  Logo   from "../assets/Image/logo.png";
import  Cover   from "../assets/Image/cover.jpg";
import  bgHeader   from "../assets/Image/header.png";

import errorPage from "../assets/Image/error-404.webp";
import errorLogo from "../assets/Image/404-spaceman.svg"
export default{
    Logo,
    bgHeader,
    Cover,
    errorPage,
    errorLogo,
}